import { render, staticRenderFns } from "./touzituijian.vue?vue&type=template&id=2eac40f6&scoped=true"
import script from "./touzituijian.vue?vue&type=script&lang=js"
export * from "./touzituijian.vue?vue&type=script&lang=js"
import style0 from "./touzituijian.vue?vue&type=style&index=0&id=2eac40f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eac40f6",
  null
  
)

export default component.exports